import { CheckCircle } from 'lucide-react';

const ICON_SIZE = 22;

// Helper function to determine step indicator styling - avoids nested ternaries
const getStepIndicatorStyle = (isDone, isActive) => {
  if (isDone) return 'bg-green-500 text-white';
  if (isActive) return 'bg-primaryOrange text-white shadow-lg scale-110';
  return 'bg-gray-200 text-gray-400';
};

const getProgressBarStyle = (isDone) => {
  return isDone ? 'bg-green-500' : 'bg-gray-200';
};

export const IntakeStepProgress = ({ steps, currentStep }) => (
  <div className="flex items-center justify-between mb-10" data-testid="intake-progress-bar">
    {steps.map((s, index) => {
      const Icon = s.icon;
      const isActive = index === currentStep;
      const isDone = index < currentStep;
      const indicatorStyle = getStepIndicatorStyle(isDone, isActive);
      
      return (
        <div key={s.label} className="flex flex-col items-center flex-1">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-2 transition-all ${indicatorStyle}`}>
            {isDone ? <CheckCircle size={ICON_SIZE} /> : <Icon size={ICON_SIZE} />}
          </div>
          <span className={`text-xs font-medium text-center ${isActive ? 'text-primaryOrange' : 'text-gray-400'}`}>
            {s.label}
          </span>
          {index < steps.length - 1 && (
            <div className={`hidden md:block absolute h-0.5 w-full ${getProgressBarStyle(isDone)}`} />
          )}
        </div>
      );
    })}
  </div>
);
